import { TextField } from '@mui/material';
import { useEffect, useState } from 'react';

type EditCellInputProps = {
  initialValue: string;
  isEditing: boolean;
  cellId: string;
  ariaLabel: string;
  onFocus: (cellId: string) => void;
  onBlur: () => void;
  onUpdate: (value: string) => Error | void;
  onEnter?: (shiftKeyPressed: boolean) => void;
};

export const EditCellInput = ({
  initialValue,
  isEditing,
  cellId,
  ariaLabel,
  onFocus,
  onBlur,
  onUpdate,
  onEnter,
}: EditCellInputProps) => {
  const [value, setValue] = useState(initialValue);

  // Reset value when initialValue changes (e.g., data updates from parent)
  useEffect(() => {
    setValue(initialValue);
  }, [initialValue]);

  const handleBlur = () => {
    onBlur();
    if (value !== initialValue) {
      const result = onUpdate(value);
      if (result instanceof Error) {
        // Revert to initial value if there was an error
        setValue(initialValue);
      }
    }
  };

  return (
    <TextField
      variant="standard"
      inputProps={{
        'data-edit-input': true,
        'aria-label': ariaLabel,
      }}
      InputProps={{
        disableUnderline: true,
        sx: { backgroundColor: 'transparent' },
      }}
      disabled={!isEditing}
      value={value}
      onChange={(e) => setValue(e.target.value)}
      onFocus={() => {
        if (isEditing) {
          onFocus(cellId);
        }
      }}
      onBlur={handleBlur}
      onKeyDown={(e) => {
        if (e.key === 'Enter') {
          e.preventDefault();
          onEnter?.(e.shiftKey);
        }
      }}
    />
  );
};
